module.exports = __webpack_public_path__ + "assets/7fc61fd615739b50dcc0f86503f005a2.mp3";